import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Suprimir errores 403 de Google Sign-In que no afectan la funcionalidad
// Estos errores son de recursos del widget de Google y no impiden el login
const originalError = console.error;
console.error = (...args: any[]) => {
  const message = args[0]?.toString() || '';
  // Filtrar errores 403 específicos de recursos del widget de Google
  if (
    message.includes('403') && 
    (message.includes('accounts.google.com/gsi/button') || 
     message.includes('accounts.google.com/gsi/iframe') ||
     message.includes('Failed to load resource: the server responded with a status of 403'))
  ) {
    return;
  }
  if (message.includes('GSI_LOGGER') && message.includes('origin is not allowed')) {
    return;
  }
  originalError.apply(console, args);
};

// Suprimir errores de red 403 relacionados con recursos del widget de Google
window.addEventListener('error', (event) => {
  if (
    event.message?.includes('403') &&
    (event.filename?.includes('accounts.google.com/gsi/button') || 
     event.filename?.includes('accounts.google.com/gsi/iframe'))
  ) {
    event.preventDefault();
    return false;
  }
}, true);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
